const NAV_KEYS = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];

/**
 * Roving-radio target for a pill keydown: Home/End jump, arrows wrap, null for any other key.
 * @param {string} key
 * @param {HTMLElement[]} pills - navigable pills in DOM order.
 * @param {Element | null} current
 * @returns {HTMLElement | null}
 */
export function nextPill(key, pills, current) {
  if (!NAV_KEYS.includes(key) || !pills.length) return null;
  if (key === 'Home') return pills[0] ?? null;
  if (key === 'End') return pills[pills.length - 1] ?? null;
  const index = Math.max(0, pills.indexOf(/** @type {HTMLElement} */ (current)));
  const forward = key === 'ArrowRight' || key === 'ArrowDown';
  return pills[(index + (forward ? 1 : pills.length - 1)) % pills.length] ?? null;
}

/**
 * Marks one pill checked and the rest unchecked with a roving tabindex.
 * @param {ParentNode} scope
 * @param {HTMLElement} pill
 */
export function checkPill(scope, pill) {
  scope.querySelectorAll('[data-variant-pill]').forEach((other) => {
    other.setAttribute('aria-checked', 'false');
    /** @type {HTMLElement} */ (other).tabIndex = -1;
  });
  pill.setAttribute('aria-checked', 'true');
  pill.tabIndex = 0;
}

/**
 * Mirrors the chosen pill's image, summary and price onto the card head inside scope.
 * @param {ParentNode} scope
 * @param {HTMLElement} pill
 */
export function syncHead(scope, pill) {
  const img = /** @type {HTMLImageElement | null} */ (scope.querySelector('[data-upsell-img]'));
  if (img && pill.dataset.variantImage) img.src = pill.dataset.variantImage;

  const summary = /** @type {HTMLElement | null} */ (scope.querySelector('[data-upsell-summary]'));
  if (summary) {
    const text = pill.dataset.variantSummary || '';
    summary.textContent = text;
    summary.hidden = text.trim() === '';
  }

  const now = scope.querySelector('[data-price-now]');
  const was = /** @type {HTMLElement | null} */ (scope.querySelector('[data-price-was]'));
  const price = pill.dataset.variantPrice || '';
  const compare = (pill.dataset.variantCompare || '').trim();
  if (now && price) {
    now.textContent = price;
    now.classList.toggle('cart-upsell__price-now--sale', compare !== '');
  }
  if (was) {
    was.textContent = compare;
    was.hidden = compare === '';
  }
}
